/**
 * Dual-gender size selector: sync sticky hidden fields, badge, enable
 * main + sticky Add to cart when both sizes are selected, and add one set
 * line via /cart/add.js with both sizes as properties (capture submit —
 * theme uses product.min.js).
 */
(function () {
  "use strict";

  function cartAddJsUrl() {
    var u = (window.routes && window.routes.cart_add_url) || "/cart/add";
    if (/\.js(\?|$)/.test(u)) return u;
    return u + ".js";
  }

  function getDualSectionIdFromForm(form) {
    if (!form || !form.id) return null;

    var pf = form.closest("product-form");
    if (
      pf &&
      pf.classList &&
      pf.classList.contains("bls__product-addtocart-form-js") &&
      !pf.closest(".bls__product-quickview")
    ) {
      return null;
    }

    var m = form.id.match(/^(?:product-form|sticky-addcart-form)-(.+)$/);
    if (!m) return null;
    var sid = m[1];

    var mainForm = document.getElementById("product-form-" + sid);
    if (!mainForm) return null;
    if (
      !mainForm.closest(".bls__template-main-product") &&
      !mainForm.closest(".bls__product-quickview")
    ) {
      return null;
    }

    return sid;
  }

  function isDualGenderProduct(sectionId) {
    var hasDualWrapper = !!document.querySelector(
      '.dual-size-selector-wrapper[data-require-both-sizes][data-section-id="' +
        sectionId +
        '"]'
    );
    var hasCustomSwatches = !!(
      document.querySelector('input[name="properties[Men\'s Size]"]') && 
      document.querySelector('input[name="properties[Women\'s Size]"]')
    );
    return hasDualWrapper || hasCustomSwatches;
  }

  function getSubmitButton(form) {
    var pf = form.closest("product-form");
    var btn =
      (pf &&
        (pf.querySelector("button.product-form__submit") ||
          pf.querySelector('button[name="add"][type="submit"]'))) ||
      form.querySelector("button.product-form__submit") ||
      form.querySelector('button[name="add"][type="submit"]') ||
      form.querySelector('button[type="submit"]');
    return btn;
  }

  function getQuantity(form, mainForm) {
    var inp =
      form.querySelector('input[name="quantity"]') ||
      (mainForm && mainForm.querySelector('input[name="quantity"]'));
    var n = inp ? parseInt(inp.value, 10) : 1;
    return isNaN(n) || n < 1 ? 1 : n;
  }

  var DUAL_SIZE_MENS_NAME = "properties[Men's Size]";
  var DUAL_SIZE_WOMENS_NAME = "properties[Women's Size]";

  function getCheckedDualSizeRadios(mainForm) {
    var mens = document.querySelector('input[name="' + DUAL_SIZE_MENS_NAME + '"]:checked');
    var womens = document.querySelector('input[name="' + DUAL_SIZE_WOMENS_NAME + '"]:checked');
    return { mens: mens, womens: womens };
  }

  /**
   * Shared validation + cart line items for dual-size add-to-cart and Buy It Now.
   * @returns {{ ok:true, items:any[], mainForm:HTMLFormElement } | { ok:false, reason:string, valMsg:HTMLElement|null, stickyVal:HTMLElement|null, mainForm:HTMLFormElement|null }}
   */
  function validateAndBuildDualCartItems(sectionId, formForQty) {
    var sid = String(sectionId);
    var mainForm = document.getElementById("product-form-" + sid);
    if (!mainForm) {
      return { ok: false, reason: "no_form", valMsg: null, stickyVal: null, mainForm: null };
    }

    var dualChecked = getCheckedDualSizeRadios(mainForm);
    var mensRadio = dualChecked.mens;
    var womensRadio = dualChecked.womens;

    var valMsg = document.getElementById("size-validation-msg-" + sid);
    var stickyVal = document.getElementById(
      "sticky-size-validation-msg-" + sid
    );

    if (!mensRadio || !womensRadio || !mensRadio.value || !womensRadio.value) {
      return {
        ok: false,
        reason: "incomplete",
        valMsg: valMsg,
        stickyVal: stickyVal,
        mainForm: mainForm,
      };
    }

    var mensVariantId = mensRadio.getAttribute("data-variant-id") || "";
    var womensVariantId = womensRadio.getAttribute("data-variant-id") || "";

    var qty = getQuantity(formForQty || mainForm, mainForm);

    // Single line per set: men's and women's picks are separate variants in Shopify but
    // the product is sold as one unit at one price. Two /cart/add lines duplicate charge.
    var items = [
      {
        id: parseInt(mensVariantId, 10),
        quantity: qty,
        properties: {
          "Men's Size": mensRadio.value,
          "Women's Size": womensRadio.value,
        },
      },
    ];

    return {
      ok: true,
      items: items,
      mainForm: mainForm,
      valMsg: valMsg,
      stickyVal: stickyVal,
      qty: qty,
    };
  }

  function showDualSizeValidationError(result) {
    if (!result || result.ok) return;
    var txt = "Please select both Men's and Women's sizes before adding to cart.";
    if (result.reason === "bad_variant") {
      txt = "Could not resolve variant for the selected sizes. Please refresh and try again.";
    }

    if (typeof EasyDialogBox !== 'undefined') {
      var prev = EasyDialogBox.getById('size_select_error_0');
      if (prev) prev.destroy();
      var dlg = EasyDialogBox.create(
        'size_select_error',
        'dlg dlg-disable-footer dlg-disable-drag dlg-disable-heading',
        '',
        '<div style="padding:2.5rem 2rem; text-align:center;"><div style="font-size:2rem; font-weight:700; margin-bottom:1.2rem; color:var(--heading-color, #222);">Size Selection Required</div><p style="font-size:1.4rem; color:#555; line-height:1.6;">Please select both a <strong>Men\'s</strong> and a <strong>Women\'s</strong> size before adding to cart.</p><p style="font-size:1.2rem; color:#999; margin-top:1rem;">Both sizes must be selected to continue.</p></div>'
      );
      dlg.onClose = dlg.destroy;
      dlg.show();
    } else {
      alert(txt);
    }
  }

  function isDualBuyNowPaymentBlocked(btn) {
    var wrap = btn.closest(".bls__payment-button");
    return !!(wrap && wrap.classList.contains("disabled"));
  }

  function updateCartFromDualAdd(parsedState, cart) {
    function refreshCartCountsOnly() {
      fetch("/cart.json")
        .then(function (res) {
          return res.json();
        })
        .then(function (cartJson) {
          if (cartJson.item_count === undefined) return;
          document.querySelectorAll(".cart-count").forEach(function (el) {
            if (el.classList.contains("cart-count-drawer")) {
              el.innerHTML = "(" + cartJson.item_count + ")";
            } else {
              el.innerHTML = cartJson.item_count;
            }
          });
          var htp = document.querySelector("header-total-price");
          if (htp && typeof htp.updateTotal === "function") {
            htp.updateTotal(cartJson);
          }
          var cartFreeShip = document.querySelector("free-ship-progress-bar");
          if (cartFreeShip && typeof cartFreeShip.init === "function") {
            cartFreeShip.init(cartJson.items_subtotal_price);
          }
        })
        .catch(function () {});
    }

    if (!cart || typeof cart.getSectionsToRender !== "function") {
      refreshCartCountsOnly();
      return;
    }

    var sectionsList = cart.getSectionsToRender();
    if (
      parsedState.sections &&
      sectionsList &&
      sectionsList.length > 0
    ) {
      sectionsList.forEach(function (section) {
        var elementToReplace = document.getElementById(section.id);
        if (
          !elementToReplace ||
          !parsedState.sections[section.id]
        ) {
          return;
        }
        var html = new DOMParser().parseFromString(
          parsedState.sections[section.id],
          "text/html"
        );
        var cartContent = html.querySelector("#form-mini-cart");
        if (cartContent) {
          elementToReplace.innerHTML = cartContent.innerHTML;
        }

        var countdown = cart.querySelector(".cart-countdown-time");
        var html_countdown = html.querySelector(".cart-countdown-time");
        if (countdown && html_countdown) {
          countdown.innerHTML = html_countdown.innerHTML;
          if (typeof cart.countdownTimer === "function") {
            cart.countdownTimer();
          }
        }

        var cartUpsell = cart.querySelector(".bls-recommendations-beside");
        var html_cartUpsell = html.querySelector(".bls-recommendations-beside");
        var html_cartUpselSelected = html.querySelector(
          ".bls-recommendations-beside-selected"
        );
        var counteSelect;
        if (cartUpsell && html_cartUpsell) {
          if (html_cartUpselSelected) {
            counteSelect = Array.from(
              html_cartUpselSelected.getElementsByClassName("bls-cart-upsell-item")
            );
            if (counteSelect.length === 0) {
              cartUpsell.classList.remove("is-opend");
            }
          }
          if (!counteSelect || counteSelect.length !== 0) {
            setTimeout(function () {
              cartUpsell.classList.add("is-opend");
            }, 1500);
          }
          cartUpsell.innerHTML = html_cartUpsell.innerHTML;
        }
      });
    }

    fetch("/cart.json")
      .then(function (res) {
        return res.json();
      })
      .then(function (cartJson) {
        if (cartJson.item_count === undefined) return;
        document.querySelectorAll(".cart-count").forEach(function (el) {
          if (el.classList.contains("cart-count-drawer")) {
            el.innerHTML = "(" + cartJson.item_count + ")";
          } else {
            el.innerHTML = cartJson.item_count;
          }
        });
        var htp = document.querySelector("header-total-price");
        if (htp && typeof htp.updateTotal === "function") {
          htp.updateTotal(cartJson);
        }
        var cartFreeShip = document.querySelector("free-ship-progress-bar");
        if (cartFreeShip && typeof cartFreeShip.init === "function") {
          cartFreeShip.init(cartJson.items_subtotal_price);
        }
      })
      .catch(function () {});

    var quantity = parsedState.quantity;
    if (document.querySelector(".quantity__label") && quantity > 0) {
      var ql = document.querySelector(".quantity-cart");
      if (ql) ql.innerHTML = quantity;
      document.querySelector(".quantity__label").classList.remove("hidden");
    }

    var pswp = document.querySelector(".pswp__button--bls--close");
    if (pswp) pswp.click();

    if (typeof cart.cartAction === "function") cart.cartAction();
    if (typeof cart.open === "function") cart.open();

    if (cart.classList && cart.classList.contains("is-empty")) {
      cart.classList.remove("is-empty");
    }

    if (typeof Shopify !== "undefined" && Shopify.termsConditionsAction) {
      Shopify.termsConditionsAction();
    }
    if (window.BlsLazyloadImg && typeof BlsLazyloadImg.init === "function") {
      BlsLazyloadImg.init();
    }
    if (window.BlsSettingsSwiper && typeof BlsSettingsSwiper.init === "function") {
      BlsSettingsSwiper.init();
    }
  }

  function showCartError(parsedState) {
    var content = document.querySelector(".form-infor .add-cart-error");
    if (!content) return;
    if (window.EasyDialogBox && parsedState && parsedState.errors) {
      var error_message = EasyDialogBox.create(
        "add_cart_error",
        "dlg dlg-disable-footer dlg-disable-drag dlg-disable-heading",
        "",
        content.innerHTML
      );
      error_message.onClose = error_message.destroy;
      error_message.show();
    }
  }

  function onDualGenderFormSubmit(ev) {
    var form = ev.target;
    if (!form || form.tagName !== "FORM") return;

    var sectionId = getDualSectionIdFromForm(form);
    if (!sectionId || !isDualGenderProduct(sectionId)) return;

    var built = validateAndBuildDualCartItems(sectionId, form);
    if (!built.ok) {
      if (built.reason === "no_form") return;
      ev.preventDefault();
      ev.stopImmediatePropagation();
      showDualSizeValidationError(built);
      return;
    }

    ev.preventDefault();
    ev.stopImmediatePropagation();

    var submitBtn = getSubmitButton(form);
    if (submitBtn) {
      submitBtn.setAttribute("disabled", "disabled");
      submitBtn.classList.add("btn-loading");
      var span = submitBtn.querySelector("span");
      if (span) span.classList.add("hidden");
    }

    var cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
    var sections =
      cart && typeof cart.getSectionsToRender === "function"
        ? cart.getSectionsToRender().map(function (s) {
            return s.id;
          })
        : [];

    var payload = {
      items: built.items,
      sections: sections,
      sections_url: window.location.pathname,
    };

    if (cart && typeof cart.setActiveElement === "function") {
      cart.setActiveElement(document.activeElement);
    }

    fetch(cartAddJsUrl(), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify(payload),
    })
      .then(function (res) {
        return res.text().then(function (text) {
          var data;
          try {
            data = JSON.parse(text);
          } catch (e) {
            throw new Error(text || "Invalid response");
          }
          return { ok: res.ok, status: res.status, data: data };
        });
      })
      .then(function (result) {
        var parsedState = result.data;
        if (
          !result.ok ||
          parsedState.errors ||
          parsedState.status === 422
        ) {
          showCartError(parsedState);
          return;
        }
        updateCartFromDualAdd(parsedState, cart);
      })
      .catch(function () {
        showCartError({ errors: true });
      })
      .finally(function () {
        if (submitBtn) {
          submitBtn.classList.remove("btn-loading");
          submitBtn.removeAttribute("disabled");
          var sp = submitBtn.querySelector("span");
          if (sp) sp.classList.remove("hidden");
        }
      });
  }

  function getDualSizeEls(sectionId) {
    var sid = String(sectionId);
    return {
      mens: document.getElementById("sticky-mens-size-" + sid),
      womens: document.getElementById("sticky-womens-size-" + sid),
      badge: document.getElementById("sticky-size-badge-" + sid),
      text: document.getElementById("sticky-size-text-" + sid),
      stickyVal: document.getElementById("sticky-size-validation-msg-" + sid),
      mainVal: document.getElementById("size-validation-msg-" + sid),
    };
  }

  function syncDualGenderSizeSection(sectionId) {
    var sid = String(sectionId);
    var mainForm = document.getElementById("product-form-" + sid);
    if (!mainForm) return;

    var dualSel = getCheckedDualSizeRadios(mainForm);
    var mens = dualSel.mens;
    var womens = dualSel.womens;

    var els = getDualSizeEls(sid);
    if (els.mens && els.womens) {
      els.mens.value = mens ? mens.value : "";
      els.womens.value = womens ? womens.value : "";
    }

    var parts = [];
    if (mens) parts.push("Men's: " + mens.value);
    if (womens) parts.push("Women's: " + womens.value);
    if (els.badge && els.text) {
      if (parts.length) {
        els.text.textContent = parts.join(" · ");
        els.badge.removeAttribute("hidden");
        els.badge.style.display = "flex";
      } else {
        els.badge.setAttribute("hidden", "hidden");
        els.badge.style.display = "none";
      }
    }

    var complete = !!(mens && womens);

    var stickyForm = document.getElementById("sticky-addcart-form-" + sid);
    if (stickyForm) {
      var submitBtn = stickyForm.querySelector(".product-form__submit");
      if (submitBtn && !submitBtn.hasAttribute("data-sold-out")) {
        if (complete) {
          submitBtn.removeAttribute("disabled");
          submitBtn.classList.remove("dual-size-incomplete");
        } else {
          submitBtn.setAttribute("disabled", "disabled");
          submitBtn.classList.add("dual-size-incomplete");
        }
      }
    }

    var mainSubmit =
      mainForm.querySelector(".add-cart-button.product-form__submit") ||
      mainForm.querySelector(".button-add-cart-qv.product-form__submit") ||
      mainForm.querySelector('button[name="add"][type="submit"]');
    if (mainSubmit && !mainSubmit.hasAttribute("data-sold-out")) {
      mainSubmit.removeAttribute("disabled");
      mainSubmit.classList.remove("dual-size-incomplete");
    }

    var productFormShell = mainForm.closest("product-form");
    var dualBuyBtns = [];
    if (productFormShell) {
      productFormShell
        .querySelectorAll(".bls__dual-buy-now-js")
        .forEach(function (b) {
          dualBuyBtns.push(b);
        });
    }
    document
      .querySelectorAll(
        '.bls__dual-buy-now-js[data-section-id="' + sid + '"]'
      )
      .forEach(function (b) {
        if (dualBuyBtns.indexOf(b) === -1) {
          dualBuyBtns.push(b);
        }
      });

    dualBuyBtns.forEach(function (buyBtn) {
      if (buyBtn.hasAttribute("data-sold-out")) return;
      var termsBlocked = isDualBuyNowPaymentBlocked(buyBtn);
      if (!termsBlocked && complete) {
        buyBtn.removeAttribute("disabled");
        buyBtn.classList.remove("dual-size-incomplete");
      } else {
        buyBtn.setAttribute("disabled", "disabled");
        buyBtn.classList.add("dual-size-incomplete");
      }
    });
  }

  function onDualGenderBuyNowClick(ev) {
    var btn =
      ev.target &&
      ev.target.closest &&
      ev.target.closest(".bls__dual-buy-now-js");
    if (!btn) return;

    var sectionId = btn.getAttribute("data-section-id");
    if (!sectionId || !isDualGenderProduct(sectionId)) return;

    if (isDualBuyNowPaymentBlocked(btn)) {
      ev.preventDefault();
      return;
    }

    var pf = btn.closest("product-form");
    var form = pf && pf.querySelector("form");

    var built = validateAndBuildDualCartItems(sectionId, form);
    if (!built.ok) {
      ev.preventDefault();
      if (built.reason === "no_form") return;
      showDualSizeValidationError(built);
      return;
    }

    var hasDualWrapper = !!document.querySelector(
      '.dual-size-selector-wrapper[data-require-both-sizes][data-section-id="' + sectionId + '"]'
    );
    if (!hasDualWrapper) {
      // It's a custom swatches product and validation passed.
      // Let the native Shopify Buy It Now handle the checkout flow.
      return;
    }

    ev.preventDefault();

    btn.setAttribute("disabled", "disabled");
    btn.classList.add("btn-loading");
    var loadSpan =
      btn.querySelector(".hidden-loading") || btn.querySelector("span");
    if (loadSpan) loadSpan.classList.add("hidden");

    var payload = { items: built.items };

    fetch(cartAddJsUrl(), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify(payload),
    })
      .then(function (res) {
        return res.text().then(function (text) {
          var data;
          try {
            data = JSON.parse(text);
          } catch (e) {
            throw new Error(text || "Invalid response");
          }
          return { ok: res.ok, status: res.status, data: data };
        });
      })
      .then(function (result) {
        var parsedState = result.data;
        if (
          !result.ok ||
          parsedState.errors ||
          parsedState.status === 422
        ) {
          showCartError(parsedState);
          return;
        }
        window.location.href = "/checkout";
      })
      .catch(function () {
        showCartError({ errors: true });
      })
      .finally(function () {
        btn.classList.remove("btn-loading");
        btn.removeAttribute("disabled");
        var sp =
          btn.querySelector(".hidden-loading") || btn.querySelector("span");
        if (sp) sp.classList.remove("hidden");
        syncDualGenderSizeSection(sectionId);
      });
  }

  function onDualGenderSizeChange(ev) {
    var t = ev.target;
    if (!t) return;
    if (t.type === "checkbox" && t.name === "conditions") {
      initAllDualGenderSections();
      return;
    }
    if (!t.name) return;
    if (
      t.name !== DUAL_SIZE_MENS_NAME &&
      t.name !== DUAL_SIZE_WOMENS_NAME
    ) {
      return;
    }
    var wrap = t.closest(
      ".dual-size-selector-wrapper[data-require-both-sizes]"
    );
    if (!wrap || !wrap.dataset.sectionId) return;
    if (
      !wrap.closest(".bls__template-main-product") &&
      !wrap.closest(".bls__product-quickview")
    ) {
      return;
    }
    var sectionId = wrap.dataset.sectionId;
    syncDualGenderSizeSection(sectionId);
    var els = getDualSizeEls(sectionId);
    if (els.mainVal) els.mainVal.style.display = "none";
    if (els.stickyVal) {
      els.stickyVal.style.display = "none";
      els.stickyVal.textContent = "";
    }
  }

  function initAllDualGenderSections() {
    document
      .querySelectorAll(".dual-size-selector-wrapper[data-require-both-sizes]")
      .forEach(function (w) {
        if (w.dataset.sectionId) {
          syncDualGenderSizeSection(w.dataset.sectionId);
        }
      });
  }

  window.LVD = window.LVD || {};
  window.LVD.syncDualSizeSection = function (sid) {
    syncDualGenderSizeSection(String(sid));
  };
  window.LVD.syncAllDualSizeSections = initAllDualGenderSections;

  if (!window.__lvdDualGenderSizeListenersBound) {
    window.__lvdDualGenderSizeListenersBound = true;
    document.addEventListener("change", onDualGenderSizeChange);
    document.addEventListener("shopify:section:load", initAllDualGenderSections);
    document.addEventListener("submit", onDualGenderFormSubmit, true);
    document.addEventListener("click", onDualGenderBuyNowClick, false);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAllDualGenderSections);
  } else {
    initAllDualGenderSections();
  }
})();
